import { supabase } from '../supabaseClient';
import { SERVICE_TYPES } from '../constants';

export async function sendPushNotification({ type, user_id, title, body, url, lat, lng, radius, service_id }) {
  try {
    const payload = { type, user_id, title, body, url };
    if (service_id) {
      payload.service_id = service_id;
    }
    if (type === 'nearby_drivers') {
      payload.lat = lat;
      payload.lng = lng;
      payload.radius = radius || 5;
    }
    const { error } = await supabase.functions.invoke('push-sender', { body: payload });
    if (error) console.error('Push notification error:', error);
    return { success: !error };
  } catch (err) {
    console.error('Push notification error:', err);
    return { success: false };
  }
}

export async function notifyNewService(serviceData) {
  const title = 'Nuevo servicio disponible';
  const body = `${serviceData.type === SERVICE_TYPES.DELIVERY ? 'Entrega' : 'Viaje'} desde ${serviceData.pickup?.address || 'tu zona'}`;
  return sendPushNotification({
    type: 'nearby_drivers',
    title,
    body,
    url: '/home',
    lat: serviceData.pickup?.lat,
    lng: serviceData.pickup?.lng,
    service_id: serviceData.service_id || serviceData.id,
  });
}

export async function notifyServiceAssigned(service, userUid) {
  const title = 'Conductor asignado';
  const body = 'Un conductor ha aceptado tu solicitud';
  await insertAppNotification(userUid, 'service_assigned', title, body, { service_id: service?.service_id });
  return sendPushNotification({
    type: 'user_id',
    user_id: userUid,
    title,
    body,
    url: '/home',
    service_id: service?.service_id,
  });
}

export async function notifyNewChatMessage(serviceId, otherUid, senderName, message) {
  const title = `Mensaje de ${senderName || 'conductor'}`;
  const body = message.length > 80 ? message.substring(0, 80) + '...' : message;
  return sendPushNotification({
    type: 'user_id',
    user_id: otherUid,
    title,
    body,
    url: '/home',
    service_id: serviceId,
  });
}

export async function notifyServiceStatusChange(service, userUid, status) {
  const labels = { assigned: 'Conductor asignado', in_progress: 'Viaje en curso', completed: 'Viaje completado', cancelled: 'Viaje cancelado' };
  const title = labels[status] || 'Estado actualizado';
  const body = `Tu servicio ha cambiado a: ${title}`;
  await insertAppNotification(userUid, `service_${status}`, title, body, { service_id: service?.service_id });
  return sendPushNotification({
    type: 'user_id',
    user_id: userUid,
    title,
    body,
    url: '/home',
    service_id: service?.service_id,
  });
}

async function insertAppNotification(userId, type, title, body, extraData) {
  try {
    // RPC SECURITY DEFINER: permite notificar a terceros sin abrir RLS.
    // p_data.service_id habilita el guard de contraparte de v9n (el
    // destinatario debe ser parte del mismo servicio que el emisor).
    await supabase.rpc('create_notification', {
      p_user_id: userId,
      p_type: type,
      p_title: title,
      p_body: body,
      p_data: extraData || null,
    });
  } catch (err) {
    console.error('Error inserting notification:', err);
  }
}
